










































































































































































































































































































import {
  defineComponent,
  computed,
  ref,
  onMounted,
} from "@nuxtjs/composition-api";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import { useConfigStore } from "~/stores/extensionApi";
import { useLoyaltyStore } from "~/stores/extensionApi";
import LoyaltyHistoryList from "./Loyalty/LoyaltyHistoryList.vue";

export default defineComponent({
  name: "MembershipCard",
  components: {
    SkeletonLoader,
    LoyaltyHistoryList,
  },
  setup() {
    const loyaltyStore = useLoyaltyStore();
    const loyaltyData = computed(() => loyaltyStore.getLoyaltyData);
    const loading = computed(() => loyaltyStore.isLoading);
    const storeConfig = useConfigStore();
    const loyaltyConfig = computed(() => storeConfig.getLoyaltyConfig);

    const loyaltyType = computed(() => {
      return loyaltyData?.value?.result?.loyalty.type;
    });

    const loyaltyName = computed(() => {
      return loyaltyData.value?.result?.loyalty?.name || '';
    });

    const currentPoints = computed(() => {
      return loyaltyData.value?.result?.loyalty?.current_points
        ? parseInt(loyaltyData.value.result.loyalty.current_points)
        : 0;
    });

    const periodToDate = computed(() => {
      return loyaltyData.value?.result?.loyalty?.period_to_date
        ? loyaltyData.value.result.loyalty.period_to_date
        : null;
    });

    const formattedPeriodToDate = computed(() => {
      if (!periodToDate.value) return null;
      const date = new Date(periodToDate.value);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day} / ${month} / ${year}`;
    });

    const isDetailActive = ref(false);
    const activeCard = ref(null);

    const toggleDetail = () => {
      isDetailActive.value = !isDetailActive.value;
    };

    const setActiveCard = (cardType) => {
      activeCard.value = cardType;
    };

    const activeIconClass = (cardType) => {
      return activeCard.value === cardType ? "active" : "";
    };

    const filteredLoyaltyConfig = computed(() => {
      return loyaltyConfig.value.filter(
        (card) => card.group_name === activeCard.value
      );
    });

    const currentLoyaltyConfig = computed(() => {
      return loyaltyConfig.value.find(
        (card) => card.group_name === loyaltyType.value
      );
    });

    onMounted(() => {
      setActiveCard(loyaltyType.value);
    });

    return {
      loyaltyData,
      loading,
      currentPoints,
      loyaltyType,
      loyaltyConfig,
      isDetailActive,
      toggleDetail,
      activeIconClass,
      activeCard,
      setActiveCard,
      filteredLoyaltyConfig,
      formattedPeriodToDate,
      currentLoyaltyConfig,
      loyaltyName,
    };
  },
});
